import { Box, Stack, Typography } from '@mui/material';
import { ReactComponent as InformationIcon } from '@icons/Alert/information.svg';

export const Information = ({ title = '', description }) => {
  return (
    <Stack direction="row" gap="12px" padding="12px" alignItems="start" bgcolor="#E7F1F9" width="100%">
      <Box flexShrink={0}>
        <InformationIcon />
      </Box>

      <Stack gap="4px" flexShrink={2}>
        {title && (
          <Typography color="grey.700" variant="label14Bold" lineHeight="18px">
            {title}
          </Typography>
        )}
        <Typography color="grey.700" variant="label14Medium" lineHeight="18px">
          {description}
        </Typography>
      </Stack>
    </Stack>
  );
};
